module.exports = __webpack_public_path__ + "img/weapon.367c4777.png";